export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TopNavbar.vue?vue&type=template&id=8310063a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Layout/TopNavbar.vue?vue&type=template&id=8310063a&scoped=true
// module id = 1650
// module chunks = 31